export default {
    '0ba18975-7ebf-4c75-b430-ac75d624c901': '0ba18975-7ebf-4c75-b430-ac75d624c901.json',
    '5cc8cae0-70b3-48a3-b7ce-a2941c6e5ae0': '5cc8cae0-70b3-48a3-b7ce-a2941c6e5ae0.json',
    '9a75525d-799f-4f67-9257-c2a3d5b95473': '9a75525d-799f-4f67-9257-c2a3d5b95473.json',
    'b84a0320-bf0c-4473-bd37-06004bf490c5': 'b84a0320-bf0c-4473-bd37-06004bf490c5.json',
    'b84a0320-bf0c-4473-bd37-06004bf490c6': 'b84a0320-bf0c-4473-bd37-06004bf490c6.json',
    '3f70cccc-df60-4937-bc8e-26ba4dafa83f': '3f70cccc-df60-4937-bc8e-26ba4dafa83f.json',
    'd4316050-ab21-40d7-ae0e-814b29357920': 'd4316050-ab21-40d7-ae0e-814b29357920.json',
}
